export default {"src":"/_next/static/media/show.16732078.svg","height":15,"width":22};